import { Switch } from '@headlessui/react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const ConsentText = ({ agreed, setAgreed, consent, className = '' }) => {
  const { t } = useTranslation()
  const { text, link, partnerLink } = consent

  // Wenn es einen partnerLink gibt, ersetze beide Platzhalter
  if (partnerLink) {
    // Teile den Text an beiden Platzhaltern
    const parts = text.split(/{{link}}|{{partnerLink}}/)

    return (
      <div className={clsx('flex gap-x-4', className)}>
        <div className='flex-shrink-0'>
          <Switch
            checked={agreed}
            onChange={setAgreed}
            className={clsx(
              agreed ? 'bg-indigo-600' : 'bg-gray-200',
              'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
            )}
          >
            <span className='sr-only'>{t('privacy_consent.switch_label')}</span>
            <span
              aria-hidden='true'
              className={clsx(
                agreed ? 'translate-x-5' : 'translate-x-0',
                'inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200'
              )}
            />
          </Switch>
        </div>
        <p className='text-sm text-gray-700'>
          {parts[0]}
          <a
            href={link.href}
            target='_blank'
            rel='noopener noreferrer'
            className='font-medium text-gray-900 underline'
          >
            {link.label}
          </a>
          {parts[1]}
          <a
            href={partnerLink.href}
            target='_blank'
            rel='noopener noreferrer'
            className='font-medium text-gray-900 underline'
          >
            {partnerLink.label}
          </a>
          {parts[2]}
        </p>
      </div>
    )
  }

  // Standard-Fall mit nur einem Link
  const parts = text.split('{{link}}')

  return (
    <div className={clsx('flex gap-x-4', className)}>
      <div className='flex-shrink-0'>
        <Switch
          checked={agreed}
          onChange={setAgreed}
          className={clsx(
            agreed ? 'bg-indigo-600' : 'bg-gray-200',
            'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
          )}
        >
          <span className='sr-only'>{t('privacy_consent.switch_label')}</span>
          <span
            aria-hidden='true'
            className={clsx(
              agreed ? 'translate-x-5' : 'translate-x-0',
              'inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200'
            )}
          />
        </Switch>
      </div>
      <p className='text-sm text-gray-700'>
        {parts[0]}
        <a
          href={link.href}
          target='_blank'
          rel='noopener noreferrer'
          className='font-medium text-gray-900 underline'
        >
          {link.label}
        </a>
        {parts[1]}
      </p>
    </div>
  )
}

ConsentText.propTypes = {
  consent: PropTypes.object.isRequired,
  agreed: PropTypes.bool.isRequired,
  setAgreed: PropTypes.func.isRequired,
  className: PropTypes.string
}

export default ConsentText
